export class AnagraficaSP {
    public denominazione: string;
    public indirizzo: string;
    public cap: string;
    public citta: string;
    public provincia: string;
    public telefono: string;
    public house_number: string;

    constructor(
        denominazione: string,
        indirizzo: string,
        cap: string,
        citta: string,
        provincia: string,
        telefono: string,
        house_number: string
    ) {
        this.denominazione = denominazione;
        this.indirizzo = indirizzo;
        this.cap = cap;
        this.citta = citta;
        this.provincia = provincia;
        this.telefono = telefono;
        this.house_number = house_number;
    }
}
